<template>
  <ClientOnly>
    <TShare :networks="getNetworks()"></TShare>
  </ClientOnly>
</template>

<script setup lang="ts">
import type { networksType } from '~~/modules/design-system/components/t-share/constants'
import { getCurrentURL } from '~/utils/getCurrentUrl'

const getNetworks = (): networksType => {
  return [
    {
      kind: 'whatsapp',
      url: getCurrentURL({
        utm_medium: 'share',
        utm_campaign: 'cabecera',
        utm_source: 'whatsapp',
      }),
      title: t('menu.share_menu.whatsapp.title'),
      message: '',
    },
    {
      kind: 'copy',
      title: t('menu.share_menu.copy.title'),
      url: getCurrentURL({
        utm_medium: 'share',
        utm_campaign: 'cabecera',
        utm_source: 'copiar_enlace',
      }),
      copiedText: t('menu.share_menu.copy.copiedText'),
    },
  ]
}
</script>
